import { Card, CardBody } from '@vnetwork/ui/primitives';
import { InfoGrid } from '@/pages/account/components/InfoGrid';
import { Avatar } from '@vnetwork/ui/primitives';
import { env } from '@/config/env';
import type { EmployeeRecord } from '@/api/employees';

interface Props { emp: EmployeeRecord }

/**
 * Profile tab — avatar, display name, external title, and the employee's
 * public-facing profile information. Corresponds to the legacy
 * Update/TabComponents/Profile panel.
 */
export function EmployeeTabProfile({ emp }: Props) {
  const avatarSrc = emp.employee_avatar
    ? `${env.storage.baseUrl}/${emp.employee_avatar}`
    : undefined;

  return (
    <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
      <Card flat>
        <CardBody>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--vn-space-4)', marginBottom: 'var(--vn-space-4)' }}>
            <Avatar
              name={emp.employee_name}
              src={avatarSrc}
              size={64}
              appearance="solid"
              tone="accent"
            />
            <div>
              <p style={{ margin: 0, fontSize: 'var(--vn-font-size-lg)', fontWeight: 'var(--vn-font-weight-semibold)', color: 'var(--vn-fg-default)' }}>
                {emp.employee_name}
              </p>
              {emp.employee_external_title ? (
                <p style={{ margin: 0, fontSize: 'var(--vn-font-size-sm)', color: 'var(--vn-fg-muted)' }}>
                  {emp.employee_external_title}
                </p>
              ) : null}
            </div>
          </div>

          <InfoGrid
            items={[
              { label: 'Display name', value: emp.employee_name },
              { label: 'External title', value: emp.employee_external_title },
              { label: 'Employee UUID', value: emp.employee_uuid, full: true },
            ]}
          />
        </CardBody>
      </Card>
    </div>
  );
}
